<template>
    <div class="modal fade" id="klammerAnwendungModal" tabindex="-1" role="dialog" aria-labelledby="klammerAnwendungModalTitle" aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered" role="document">
        <div class="modal-content ">
        <div class="modal-header">
            <h5 class="modal-title" id="klammerAnwendungModalTitle">Anwendungsbeispiele</h5>
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
            <span aria-hidden="true">&times;</span>
            </button>
        </div>
        <div class="modal-body">
            <div id="carouselExampleIndicators" class="carousel slide" data-ride="carousel">
                <ol class="carousel-indicators">
                    <li data-target="#carouselExampleIndicators" data-slide-to="0" class="active"></li>
                    <li data-target="#carouselExampleIndicators" data-slide-to="1"></li>
                    <li data-target="#carouselExampleIndicators" data-slide-to="2"></li>
                </ol>
                <div class="carousel-inner">
                    <div class="carousel-item active">
                        <img class="" src="../assets/img/seitlichesBild.jpg" width="100%">
                    </div>
                    <div class="carousel-item">
                        <img class="mt-2" src="../assets/img/frontalesBild.jpg" width="100%">
                    </div>
                    <div class="carousel-item">
                        <img class="mt-2" src="../assets/img/HalterungmitKlammern.jpg" width="100%">
                    </div>
                </div>
                <a class="carousel-control-prev" href="#carouselExampleIndicators" role="button" data-slide="prev">
                    <span class="carousel-control-prev-icon" aria-hidden="true"></span>
                    <span class="sr-only">Previous</span>
                </a>
                <a class="carousel-control-next" href="#carouselExampleIndicators" role="button" data-slide="next">
                    <span class="carousel-control-next-icon" aria-hidden="true"></span>
                    <span class="sr-only">Next</span>
                </a>
            </div>
                
                
                
        </div>
        </div>
    </div>
    </div>
</template>


<script>

export default {
  name: 'KlammerAnwendungModal',
  props: {

  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>
